<template lang="pug">
  
  .wrapper.wrapper-content.animated.fadeInRight
    .row
      .col-lg-12
        .ibox.float-e-margins
          .ibox-title
            .ibox-tools
              router-link(to="/users/create").btn.btn-link <i class="fa fa-plus"></i> Add User
          
          .ibox-content
            .row(v-show="loading")
              .col-xs-12
                h1 Loading...
            .table-responsive
              table.table.table-striped
                thead
                  tr
                    th CREATE
                    th UPDATE
                    th NAME
                    th USERNAME
                    th ROLE
                    th.text-center STATUS
                    th
                tbody
                  tr(v-for="user in users" :class="user.del_flag == '1' ? 'text-danger' : ''")
                    td {{ formatDate(user.create_date) }}
                    td {{ formatDate(user.update_date) }}
                    td {{ user.name }}
                    td {{ user.username }}
                    td {{ user.role_name }}
                    td.col-xs-1.text-center: i.fa.fa-2x(:class="user.del_flag == '0' ? 'fa-check-circle text-info' : 'fa-times-circle text-danger'" @click="toggleDelete({ id: user.id, flag: user.del_flag })")
                    td.col-xs-2.text-right
                      div(v-if="user.del_flag == '0'")
                        router-link(:to="`/users/${user.id}/repass`").btn.btn-xs.btn-white Re-Password
                        | &nbsp;
                        router-link(:to="`/users/${user.id}`").btn.btn-xs.btn-white Edit

</template>

<script>
  import axios from 'axios'
  import moment from 'moment'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.min.css'
  import toastr from 'toastr'
  import 'toastr/build/toastr.min.css'

  export default {
    data () {
      return {
        loading: false,
        users: []
      }
    },
    created () {
      this.fetchUsers()
    },
    methods: {
      formatDate (datetime) {
        return moment(datetime).format('D MMM YYYY')
      },
      fetchUsers () {
        this.loading = true
        this.users = []
        axios.get('user').then((res) => {
          switch (res.data.responseCode) {
            case 200:
              this.users = res.data.data
              console.log(res)
              break
            case 405:
              toastr.error('This account has login by other.', res.data.message, { timeOut: 4000 })
              this.$router.push('/login')
              break
            case 406:
              toastr.error('This account has been deleted please contact admin.', res.data.message, { timeOut: 4000 })
              this.$router.push('/login')
              break
            default:
              console.log(res.data.message)
          }
          this.loading = false
        })
      },
      toggleDelete (data) {
        var _this = this
        swal({
          title: 'Are you sure?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: data.flag === '0' ? 'Delete!' : 'Restore',
          cancelButtonText: 'No'
        }).then(function () {
          if (data.flag === '0') {
            axios.delete(`user/id/${data.id}`).then((res) => {
              switch (res.data.responseCode) {
                case 200:
                  swal(
                    'Deleted!',
                    'This account has been deleted.',
                    'success'
                  )
                  break
                case 405:
                  toastr.error('This account has login by other.', res.data.message, { timeOut: 4000 })
                  this.$router.push('/login')
                  break
                case 406:
                  toastr.error('This account has been deleted please contact admin.', res.data.message, { timeOut: 4000 })
                  this.$router.push('/login')
                  break
                default:
                  console.log(res.data.message)
              }
              _this.fetchUsers()
            })
          } else {
            axios.put(`user/id/${data.id}`).then((res) => {
              switch (res.data.responseCode) {
                case 200:
                  swal(
                    'Restored!',
                    'This account has been restored.',
                    'success'
                  )
                  break
                case 405:
                  toastr.error('This account has login by other.', res.data.message, { timeOut: 4000 })
                  this.$router.push('/login')
                  break
                case 406:
                  toastr.error('This account has been deleted please contact admin.', res.data.message, { timeOut: 4000 })
                  this.$router.push('/login')
                  break
                default:
                  console.log(res.data.message)
              }
              _this.fetchUsers()
            })
          }
        }, function (dismiss) {
          if (dismiss === 'cancel') {
            swal(
              'Cancelled',
              data.flag === '0' ? 'This account is safe :)' : 'This account still gone :(',
              'error'
            )
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?3dbf8146